import React from 'react';
import PropTypes from 'prop-types';
import { classes, st } from './WsrMonthDropdown.st.css';
import setMonth from 'date-fns/setMonth';
import { DatePickerDropdown, } from '../../DatePickerDropdown';
const optionsOf = (items) => items.map((item, index) => ({
    value: item,
    id: index,
}));
const MonthDropdown = ({ className, months, date, onChange, ariaLabel, ariaLabelledBy, }) => {
    // months is string[]
    // options is { value: string, id: number }[]
    const options = optionsOf(months);
    const selectedMonth = options.find(({ id }) => id === date.getMonth());
    return (React.createElement(DatePickerDropdown, { dataHook: "datepicker-month-dropdown", className: st(classes.root, className), caption: selectedMonth.value, options: options, selectedId: selectedMonth.id, onChange: ({ id }) => onChange(setMonth(date, id)), ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy }));
};
MonthDropdown.propTypes = {
    className: PropTypes.string,
    months: PropTypes.arrayOf(PropTypes.string).isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    onChange: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
    ariaLabelledBy: PropTypes.string,
    tabIndex: PropTypes.number,
};
export default MonthDropdown;
//# sourceMappingURL=MonthDropdown.js.map